export enum PanelType {
  IssueDetailPanel = "issue-detail-panel",
  FilterPanel = "filter-panel",
  ExportPanel = "export-panel",
  BulkEditPanel = "bulk-edit-panel",
  None = "none",
}
